import { EditorSteps } from '../../../constants';
import type { StepWithCondition } from '../../../hooks/useTileEditorSteps';
import { DataStreamShapingLabels } from './DataStreamShapingLabels';
import { ShapingStep } from './ShapingStep';

interface UseShapingStepParameters {
    isLoading: boolean;
    hasDataStream: boolean;
    isConfigured: boolean;
}

/**
 * Create an object representing a shaping step.
 */
export const useShapingStep = ({
    isLoading,
    hasDataStream,
    isConfigured
}: UseShapingStepParameters): StepWithCondition => {
    const isEnabled = !isLoading && hasDataStream && isConfigured;

    return {
        name: EditorSteps.shaping,
        isEnabled,
        Sublabel: DataStreamShapingLabels,
        sublabelProps: {},
        Content: ShapingStep,
        contentProps: {}
    };
};
